var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.783,
    height: 13.785,
    viewBox: "0 0 13.783 13.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "home",
    d: "M13.412,6h0L7.788.372a1.269,1.269,0,0,0-1.795,0L.374,5.992.368,6A1.268,1.268,0,0,0,1.213,8.16l.039,0h.224V12.3a1.487,1.487,0,0,0,1.485,1.485h2.2a.4.4,0,0,0,.4-.4V10.137a.678.678,0,0,1,.678-.678h1.3a.678.678,0,0,1,.678.678v3.244a.4.4,0,0,0,.4.4h2.2A1.487,1.487,0,0,0,12.307,12.3V8.161h.208A1.269,1.269,0,0,0,13.412,6Zm0,0",
    transform: "translate(0.001)",
    fill: "#a6acb5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconDark);
export default __webpack_public_path__ + "static/media/home-icon-dark.a532fda9b6af3624cf99d1af673f3edd.svg";
export { ForwardRef as ReactComponent };